// Solana Configuration
export const SOLANA_NETWORK = process.env.REACT_APP_SOLANA_NETWORK || 'mainnet-beta';
export const SOLANA_RPC_ENDPOINT = 
  SOLANA_NETWORK === 'mainnet-beta' 
    ? 'https://api.mainnet-beta.solana.com'
    : 'https://api.devnet.solana.com';

// $BODY Token Mint Address - LIVE ON MAINNET! 🚀
// Created: Mainnet deployment
// Deployer Wallet: JxHFDW91nRXNBsV39RMbjrJW37Vndtd9GVHPts4iVC8
export const BODY_TOKEN_MINT = 'HVjfYg327vUiYrATQfd74NdkNEqQQk4NxhGtMAnMF7CE';

// Token Info
export const TOKEN_INFO = {
  name: 'BuyMeABody Token',
  symbol: 'BODY',
  decimals: 9,
  totalSupply: 1_000_000_000,
  description: 'The native token of BuyMeABody.robotics - powering the future robot economy',
  isMockToken: false, // LIVE TOKEN! 🎉
  network: 'mainnet-beta',
  explorerUrl: `https://explorer.solana.com/address/${BODY_TOKEN_MINT}`
};
